import { useState, useCallback, useEffect } from "react";
import { getMobileAppState } from "@root/shared/utils";
import { ANDROID_APP_ID, IOS_APP_ID } from "@root/shared/utils/constants";

declare const webkit: any; // eslint-disable-line @typescript-eslint/no-explicit-any
declare const Android: any; // eslint-disable-line @typescript-eslint/no-explicit-any
const mobileAppDataNum = getMobileAppState();

export const useSalonTourButton = (): {
  handleClickSalonTourButton: (params: {
    isApp: boolean;
    workCode: string;
    isScouted: boolean;
    clientShopId?: string | number;
    salonTourEntryUrl?: string;
  }) => void;
} => {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    const resetClickFlag = () => {
      setIsClicked(false);
    };

    window.addEventListener("pageshow", resetClickFlag);

    return () => {
      window.removeEventListener("pageshow", resetClickFlag);
    };
  }, []);

  const handleClickSalonTourButton = useCallback(
    (params: {
      isApp: boolean;
      workCode: string;
      isScouted: boolean;
      clientShopId?: string | number;
      salonTourEntryUrl?: string;
    }) => {
      const { isApp, workCode, isScouted, clientShopId, salonTourEntryUrl } = params;

      const eventData = {
        message: "tour_entry",
        work_code: workCode,
        client_shop_id: clientShopId,
        scout_flag: isScouted,
      };

      if (isApp) {
        if (mobileAppDataNum === IOS_APP_ID) {
          // iOS
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
          return webkit?.messageHandlers?.callbackHandler?.postMessage(eventData);
        }
        if (mobileAppDataNum === ANDROID_APP_ID) {
          // Android
          // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
          return Android && Android.postMessage("TourEntry", JSON.stringify(eventData));
        }
        return null;
      }

      if (!isClicked) {
        setIsClicked(true);
        if (salonTourEntryUrl) {
          window.location.href = salonTourEntryUrl;
        }
      }
      return null;
    },
    [isClicked],
  );
  return { handleClickSalonTourButton };
};
